import { GeoDsMeta } from './meta-data.model';

export class UserRolePermission extends GeoDsMeta {
  CanCreate: boolean;
  CanDelete: boolean;
  CanUpdate: boolean;
  CanView: boolean;
  Context: string;
  Name: string;
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
